/**
 * 短剧管理 → 基础配置
 *
 * 子 Tab：
 * - 提示词模板
 * - 系统配置
 *
 * 这只是一个容器组件，不引入新业务逻辑；子组件维持原有职责与状态。
 */

import { useState } from 'react';
import { FileText, Settings } from 'lucide-react';

import DirectorPromptTemplatesTab from './DirectorPromptTemplatesTab';
import DirectorSystemConfigTab from './DirectorSystemConfigTab';

type SubTab = 'promptTemplates' | 'system';

const SUB_TABS: Array<{ key: SubTab; label: string; icon: typeof FileText }> = [
  { key: 'promptTemplates', label: '提示词模板', icon: FileText },
  { key: 'system', label: '系统配置', icon: Settings },
];

export default function DirectorBasicConfigTab() {
  const [active, setActive] = useState<SubTab>('promptTemplates');

  return (
    <div className="space-y-4">
      <div className="border-b border-light-border flex items-center gap-1 overflow-x-auto">
        {SUB_TABS.map((tab) => {
          const Icon = tab.icon;
          const activeFlag = active === tab.key;
          return (
            <button
              key={tab.key}
              onClick={() => setActive(tab.key)}
              className={`flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${
                activeFlag
                  ? 'border-accent-blue text-accent-blue'
                  : 'border-transparent text-light-muted hover:text-light-text'
              }`}
            >
              <Icon className="w-4 h-4" />
              {tab.label}
            </button>
          );
        })}
      </div>

      <div>
        {active === 'promptTemplates' && <DirectorPromptTemplatesTab />}
        {active === 'system' && <DirectorSystemConfigTab />}
      </div>
    </div>
  );
}
